module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.$t('index.login')))]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered is-centered"
  }, [_c('div', {
    staticClass: "column is-one-third-tablet is-one-quarter-desktop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.email')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.password')))]), _vm._v(" "), _c('p', {
    staticClass: "control has-text-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('index.password')
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changePass
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.forgot_password_link')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('index.login_message'))
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button  is-medium is-primary ",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.login')))])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isForgotPassword,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isForgotPassword = $event
      }
    }
  }, [_c('forgotpassword')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18afcd9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Login.vue
// module id = 301
// module chunks = 2